<template>
  <div class="d-flex" id="wrapper">
    <div id="sidebar-wrapper">
      <Sidebar :toggler.sync="isToggled" />
      <!-- Page Content -->
    </div>

    <div id="page-content-wrapper">
      <TopNavbar @toggled="toggleSidebarNav" :profile="getUserProfile" />
      <JobsList />
    </div>

    <!-- End page-content-wrapper -->
  </div>
</template>

<script>
import { toggleSidebarNav } from '../../mixins/toggleSidebarNav';
import Sidebar from '@/components/Navigations/Sidebar';
import TopNavbar from '@/components/Navigations/TopNavbar';
import JobsList from '@/components/Admin/Jobs/JobsList';

import { mapGetters, mapActions } from 'vuex';

export default {
  components: {
    Sidebar,
    TopNavbar,
    JobsList,
  },
  mixins: [toggleSidebarNav],
  data: () => ({
    isToggled: false,
  }),
  methods: {
    ...mapActions(['retrieveUserProfile']),
    ...mapActions('recruiterStoreModule', ['retrieveRecruiterProfile']),
  },
  computed: {
    ...mapGetters(['getUserProfile']),
    ...mapGetters('recruiterStoreModule', ['getRecruiterProfile']),
    getComputedUserProfile() {
      return this.$route.name == 'recruiter-jobs' ? this.getRecruiterProfile : this.getUserProfile;
    },
  },
  mounted() {
    this.retrieveUserProfile().then(() => {
      if (sessionStorage.getItem('first') !== '1') {
        this.$toasted.success(`Welcome back, ${this.getUserProfile.first_name}!`, {
          theme: 'bubble',
          icon: 'fa-check-circle',
          position: 'bottom-right',
          duration: 5000,
        });
      }
      sessionStorage.setItem('first', '1');
    });

    /* switch (this.$route.name) {
      case 'recruiter-jobs':
        return this.retrieveRecruiterProfile();
      case 'admin-jobs':
        return this.retrieveUserProfile();
      default:
        break;
    } */
  },
};
</script>
